'use client';

import { createContext, useContext } from 'react';

const LightboxContainerContext = createContext<HTMLElement | null>(null);

export const LightboxContainerProvider = LightboxContainerContext.Provider;

export function useLightboxContainer() {
  return useContext(LightboxContainerContext);
}
